var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1200" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("EditaFechasReprogramacion"),
      _vm._v(" "),
      _c("VolverEstadoInicialReprogramacion"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("edit")]),
                  _vm._v(" Edición de reprogramación de vacaciones\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "py-0 px-3" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "p-0",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("span", { staticClass: "texto" }, [
                                _c("strong", { staticClass: "texto" }, [
                                  _vm._v("Fecha desde: ")
                                ]),
                                _vm._v(
                                  _vm._s(this.form.fecha_desde) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "p-0",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("span", { staticClass: "texto" }, [
                                _c("strong", { staticClass: "texto" }, [
                                  _vm._v("Fecha hasta: ")
                                ]),
                                _vm._v(
                                  _vm._s(this.form.fecha_hasta) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "p-0",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("span", { staticClass: "texto" }, [
                                _c("strong", { staticClass: "texto" }, [
                                  _vm._v("Días para reprogramar: ")
                                ]),
                                _vm._v(
                                  _vm._s(this.form.total_dias) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "p-0", attrs: { xs12: "" } },
                            [
                              _c("span", { staticClass: "texto" }, [
                                _c("strong", { staticClass: "texto" }, [
                                  _vm._v(
                                    "REPROGRAMACIONES A PONER EN ESTADO INICIAL"
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.lista_reprogramaciones_sin_edicion,
                          "hide-actions": "",
                          headers: _vm.headers,
                          loading: _vm.loading_tabla2,
                          "no-data-text": "No se tiene registros",
                          "no-results-text": "No se encontraron coincidencias"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.secuencia) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.fecha_desde) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.fecha_hasta) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.total_dias) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.estado) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-center" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "rgb(149,0,255)",
                                          icon: "",
                                          dark: "",
                                          outline: "",
                                          title:
                                            "Volver a estado inicial(Reprogramación aprobada)"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.volverEstadoInicial(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("undo")])],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("span", { staticClass: "texto" }, [
                        _c("strong", { staticClass: "texto" }, [
                          _vm._v("MODIFICAR REPROGRAMACIONES.")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "p-0", attrs: { xs12: "" } },
                            [
                              _c("strong", [
                                _vm._v(
                                  "Ingrese la nueva fecha de su reprogramación: "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha inicio",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calculaDiasHabiles()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde_rep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde_rep", $$v)
                                  },
                                  expression: "form.fecha_desde_rep"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs: "", "12md4": "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha fin",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calculaDiasHabiles()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_hasta_rep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta_rep", $$v)
                                  },
                                  expression: "form.fecha_hasta_rep"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Días",
                                  outline: "",
                                  clearable: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.total_dias_solicitados,
                                  callback: function($$v) {
                                    _vm.total_dias_solicitados = $$v
                                  },
                                  expression: "total_dias_solicitados"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    block: "",
                                    disabled:
                                      !_vm.form.fecha_desde_rep ||
                                      !_vm.form.fecha_hasta_rep
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.agregarReprogramacion()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("arrow_downward")]),
                                  _vm._v(
                                    "\n                Registrar\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "text-md-center" },
                [
                  _vm.loading_tabla
                    ? _c("v-progress-circular", {
                        attrs: {
                          size: 80,
                          width: 7,
                          color: "purple",
                          indeterminate: ""
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading_tabla
                ? _c(
                    "v-card-text",
                    { staticClass: "py-0 px-3" },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "p-0",
                          staticStyle: { "min-width": "100%" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.lista_reprogramaciones,
                                      "hide-actions": "",
                                      headers: _vm.headers,
                                      loading: _vm.loading_tabla,
                                      "no-data-text": "No se tiene registros",
                                      "no-results-text":
                                        "No se encontraron coincidencias"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.secuencia
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.fecha_desde
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.fecha_hasta
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.total_dias
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.estado
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "error",
                                                        icon: "",
                                                        title: "Eliminar",
                                                        outline: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.eliminarReprogramacion(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "#7b68ee",
                                                        icon: "",
                                                        title: "Editar",
                                                        outline: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.editaFechasReprogramacion(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("edit")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      757890793
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "1.2em" } },
                                    [
                                      _c("b", { staticClass: "blue--text" }, [
                                        _vm._v("TOTAL DÍAS: ")
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm.lista_reprogramaciones.reduce(
                                            function(
                                              acumulador,
                                              reprogramacion
                                            ) {
                                              return (
                                                acumulador +
                                                parseFloat(
                                                  reprogramacion.total_dias
                                                )
                                              )
                                            },
                                            0
                                          ) +
                                            _vm.lista_reprogramaciones_sin_edicion.reduce(
                                              function(
                                                acumulador,
                                                reprogramacion
                                              ) {
                                                return (
                                                  acumulador +
                                                  parseFloat(
                                                    reprogramacion.total_dias
                                                  )
                                                )
                                              },
                                              0
                                            )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "text",
                                      label: "Motivo",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.motivo,
                                      callback: function($$v) {
                                        _vm.motivo = $$v
                                      },
                                      expression: "motivo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "blue",
                                        block: "",
                                        dark: "",
                                        loading: _vm.loading
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.save()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("save")]),
                                      _vm._v(
                                        "\n                GUARDAR CAMBIOS\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-831cb0fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-831cb0fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/EditarReprogramacionRRHH.vue
// module id = null
// module chunks = 